import { Tag as AntTag, Badge, Space } from "antd";

type TagProps = {
	color?: string;
	text: string;
};

const Tag = ({ color, text }: TagProps) => (
	<AntTag style={{ borderRadius: 100 }} color={color}>
		<Space>
			<Badge color={color || "grey"} />
			{text}
		</Space>
	</AntTag>
);

export default Tag;
